import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AuxiliaryDataFilterService } from '../../../filters';
import {
  DataEntryComparison,
  DataEntryComponent,
  DataEntryReturn,
} from '../../create-company/data-entry/data-entry.component';
import { customContactDataKey } from '../../../filters/definitions/auxiliary-data-filter/data-keys';
import { MatDialog } from '@angular/material/dialog';
import { CrmFieldSelectorDialogComponent } from '../../create-company/crm-field-selector-dialog/crm-field-selector-dialog.component';
import { take } from 'rxjs/operators';
import { GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@Component({
  selector: 'automata-lookup-contact-panel',
  templateUrl: './lookup-contact-panel.component.html',
  styleUrls: ['./lookup-contact-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    DataEntryComponent,
    MatButtonToggleModule,
  ],
})
export class LookupContactPanelComponent extends CommonActionPanelComponent implements OnInit {
  components$ = this.auxService.getCRMObjectDataEntryComponents(customContactDataKey, 'Contact');
  formArray = new FormArray<FormControl<DataEntryReturn>>([], Validators.required);
  joinType: 'AND' | 'OR' = 'AND';
  comparisons: DataEntryComparison[] = [
    {
      label: 'AUTOMATIONS.EDITOR.TASKS.LOOKUP_CONTACT.OPERATOR.IS',
      value: GalaxyFilterOperator.FILTER_OPERATOR_IS,
    },
  ];

  constructor(
    private readonly auxService: AuxiliaryDataFilterService,
    private dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    const jsonData = this.step ? JSON.parse(this.step.data) : { filters: [] };
    jsonData?.filters?.map((filter) => {
      this.formArray.push(
        new FormControl<DataEntryReturn>({
          fieldId: filter.field_id,
          value: filter.value,
          comparisonValue: GalaxyFilterOperator.FILTER_OPERATOR_IS,
        }),
      );
    });
    this.joinType = jsonData?.join_type ?? 'AND';

    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step?.data ?? '') : {};
    jsonData.filters = this.formArray.controls
      .filter((c) => c?.value?.fieldId && (c?.value?.value !== null || c?.value?.value !== undefined))
      .map((c) => ({
        field_id: c?.value?.fieldId,
        value: c?.value?.value,
        operator: GalaxyFilterOperator.FILTER_OPERATOR_IS,
      }));
    jsonData.join_type = this.joinType;
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.formArray];
  }

  isFormValid(): boolean | string {
    return this.formArray.valid;
  }

  addDataEntryComponent(): void {
    this.dialog
      .open(CrmFieldSelectorDialogComponent, {
        data: {
          crmObjectType: 'Contact',
        },
        width: '400px',
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((fieldIds) => {
        (fieldIds || []).forEach((fieldId: string) => {
          this.formArray.push(
            new FormControl({
              fieldId: fieldId,
              value: '',
              comparisonValue: GalaxyFilterOperator.FILTER_OPERATOR_IS,
            }),
          );
        });
        this.cdr.detectChanges();
      });
  }

  removeDataEntryComponent(index: number): void {
    this.formArray.removeAt(index);
  }
}
